/* 🤖 this file was generated by svg-to-ts */
export const matIconSensorWindow: {
  name: 'sensor-window';
  data: string;
} = {
  name: 'sensor-window',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 2v7h-4v-1h-4v1H6V4h12zM6 20v-7h12v7H6z"/></svg>`
};
